import { render, staticRenderFns } from "./TagBar.vue?vue&type=template&id=0d112eea"
import script from "./TagBar.vue?vue&type=script&lang=js"
export * from "./TagBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports